import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-submitpage',
  templateUrl: './submitpage.component.html',
  styleUrls: ['./submitpage.component.css']
})
export class SubmitpageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
